// extracted by mini-css-extract-plugin
export default {"dtg-list-item-dropdown__container":"dtg-list-item-dropdown__container_xsUTu"};